module.exports = __webpack_public_path__ + "static/media/ias-tap.c662c4c4.png";